import React from 'react';
interface SectionProps {
  children: ReactNode;
  className?: string;
  id?: string;
  background?: 'white' | 'cream' | 'rose' | 'lavender';
}
export function Section({
  children,
  className = '',
  id,
  background = 'white'
}: SectionProps) {
  const bgColors = {
    white: 'bg-white',
    cream: 'bg-[#FDFBF7]',
    rose: 'bg-rose-50',
    lavender: 'bg-purple-50'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${bgColors[background]} ${className}`} data-id="element-216">
      <div className="mx-auto max-w-4xl" data-id="element-217">{children}</div>
    </section>;
}